<div *transloco="let t; read: 'profile-list-filters'"
  class="results-filter-container"
  aria-labelledby="filters"
  [class.open]="menuOpen()"
  [class.ghost]="isInitialLoad()"
  [attr.role]="isDesktop ? 'region' : 'dialog'"
  [attr.aria-label]="t('aria_filters')"
  [cdkTrapFocus]="menuOpen()">

  <div class="filter-header">
    <h2 id="filters"
      class="filters-title mat-h2 no-margin">
      <button mat-icon-button
        id="closeFilters"
        [attr.aria-label]="t('aria_back_to_results')"
        (click)="onFilterMenuClose()">
        <mat-icon class="mat-icon-rtl-mirror">arrow_back_ios</mat-icon>
      </button>
      <span>{{ t('filters') }}</span>
    </h2>

    @if (hasFiltersApplied$ | async) {
      <button mat-stroked-button
        class="mat-default"
        (click)="onClearFilters()">
        {{ t('clear') }}
      </button>
    }
  </div>

  @if (isInitialLoad()) {
    <div class="ghosts-filters">
      <div></div>
      <div></div>
      <div></div>
    </div>
  }

  @if (showDefaultFilters() && directoryFilters()) {
    @if (directoryFilters().organizations) {
      <sl-profile-list-issuer-filter/>
    }

    @if (directoryFilters().groups) {
      <sl-profile-list-group-filter/>
    }

    @if (directoryFilters().location) {
      <sl-profile-list-location-filter/>
    }

    @if (directoryFilters().skills) {
      <sl-profile-list-skill-filter/>
    }

    @if (directoryFilters().availability) {
      <sl-profile-list-availability-filter/>
    }

    @if (directoryFilters().categories) {
      <sl-profile-list-skill-category-filter/>
    }
  }

  @if (directoryCustomAttributeFilters()?.length > 0) {
    <sl-custom-attribute-filters [customAttributeFilters]="directoryCustomAttributeFilters()"/>
  }

  <button mat-flat-button
    class="close-button"
    color="primary"
    id="lastControl"
    (click)="onFilterMenuClose()">Close filters
  </button>
</div>
